import { LinkField, useFieldHelper } from 'framework/ui/field';
import IconButton from '@mui/material/IconButton';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import { useNavigate } from 'react-router-dom';
import { useShowContext } from 'framework/show';
import {
  ACCESS_INFO_ACTIONS,
  ACCESS_INFO_SECTIONS,
  RISK_STATUS,
  useProjectSecurityContext,
  useNewProjectUrl,
} from 'domain/shared/newProject';

interface RiskFieldProps {
  projectId: string;
  idSource: string;
  aliasSource: string;
  newRiskForm?: boolean;
}

const RiskField = ({ projectId, idSource, aliasSource = '', newRiskForm }: RiskFieldProps) => {
  const { getValue: getProjectId } = useFieldHelper({ source: projectId });
  const { getValue: getIdValue } = useFieldHelper({ source: idSource });
  const { getValue: getAliasValue } = useFieldHelper({ source: aliasSource });
  const { getUpdateRiskUrl } = useNewProjectUrl();
  const navigate = useNavigate();
  const riskId = getIdValue();
  const project = getProjectId();
  const { data } = useShowContext();
  const { isAccessGranted } = useProjectSecurityContext();

  const canManageRisk =
    isAccessGranted(ACCESS_INFO_SECTIONS.RISK, ACCESS_INFO_ACTIONS.MANAGE) ||
    isAccessGranted(ACCESS_INFO_SECTIONS.RISK, ACCESS_INFO_ACTIONS.PARTIAL_MANAGE);

  if (!canManageRisk) {
    return null;
  }

  return (
    <>
      {!newRiskForm && data.status === RISK_STATUS.ACTIVE && (
        <IconButton onClick={() => navigate(getUpdateRiskUrl(project, riskId))} data-testid="update-button">
          <AppRegistrationIcon color="primary" />
        </IconButton>
      )}
      {newRiskForm && <LinkField isInternal value={getUpdateRiskUrl(project, riskId)} linkText={getAliasValue()} />}
    </>
  );
};

export default RiskField;
